module.exports = __webpack_public_path__ + "img/permanencia_sched.ea160ea0.svg";